exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RideRequestSearch_root_23PiK {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding-top: 56px;\n  padding-left: 16px;\n  padding-right: 16px;\n  z-index: 10;\n  transition: all 0.3s ease;\n  pointer-events: none;\n}\n\n.RideRequestSearch_root_23PiK.RideRequestSearch_open_QKoUh {\n  background-color: #fff;\n  pointer-events: auto;\n}\n\n.RideRequestSearch_searchWrapper_1ABPd {\n  position: relative;\n  max-width: 400px;\n  margin: 0 auto;\n  height: 100%;\n}\n\n.RideRequestSearch_scheduleIcon_dEOXB {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 12px;\n  z-index: 1;\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.RideRequestSearch_schedule_2VWtN .RideRequestSearch_input_1x6Cu {\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 6px, rgba(0, 0, 0, 0.1) 0px 1px 4px;\n  -webkit-appearance: none; /* iOS 7 */\n  border: none;\n  padding: 16px 52px 16px 16px;\n  z-index: 1;\n  position: absolute;\n  pointer-events: auto;\n}\n", ""]);

// exports
exports.locals = {
	"root": "RideRequestSearch_root_23PiK",
	"open": "RideRequestSearch_open_QKoUh",
	"searchWrapper": "RideRequestSearch_searchWrapper_1ABPd",
	"scheduleIcon": "RideRequestSearch_scheduleIcon_dEOXB",
	"schedule": "RideRequestSearch_schedule_2VWtN",
	"input": "RideRequestSearch_input_1x6Cu"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/RideRequestSearch/RideRequestSearch.css
// module id = 1249
// module chunks = 2